'use client';

import { useEffect, useState } from 'react';

const NAV_SECTIONS = [
  { id: 'features', label: 'Features' },
  { id: 'pricing', label: 'Pricing' },
] as const;

export function NavLinks() {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const elements = NAV_SECTIONS.map(({ id }) =>
      document.getElementById(id)
    ).filter(Boolean) as HTMLElement[];

    if (elements.length === 0) return;

    const visible = new Set<string>();

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visible.add(entry.target.id);
          } else {
            visible.delete(entry.target.id);
          }
        }
        const first = NAV_SECTIONS.find(({ id }) => visible.has(id));
        setActiveId(first?.id ?? null);
      },
      { rootMargin: '-80px 0px -40% 0px' }
    );

    for (const el of elements) observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {NAV_SECTIONS.map(({ id, label }) => (
        <a
          key={id}
          href={`#${id}`}
          className={`relative py-2 transition-colors ${
            activeId === id ? 'text-white' : 'text-slate-300 hover:text-white'
          }`}
        >
          {label}
          <span
            className={`absolute -bottom-0.5 left-1/2 -translate-x-1/2 h-1 w-1 rounded-full bg-white transition-opacity ${
              activeId === id ? 'opacity-100' : 'opacity-0'
            }`}
          />
        </a>
      ))}
    </>
  );
}
